import React from 'react';

function About({ about }) {
  return (
    <section className="portfolioSection sectionReveal" id="about">
      <div className="portfolioSection__heading">
        <span className="portfolioEyebrow">About</span>
        <h2>A bit about me</h2>
      </div>

      <div className="portfolioAbout">
        <article className="portfolioPanel portfolioPanel--large">
          <p className="portfolioLead">{about.intro}</p>
          <div className="portfolioAbout__philosophy">
            <span>How I work</span>
            <p>{about.philosophy}</p>
          </div>
        </article>

        <article className="portfolioPanel">
          <h3>Key strengths</h3>
          <ul className="portfolioList">
            {about.strengths.map((item) => <li key={item}>{item}</li>)}
          </ul>
        </article>

        <article className="portfolioPanel">
          <h3>Current focus</h3>
          <ul className="portfolioList">
            {about.focus.map((item) => <li key={item}>{item}</li>)}
          </ul>
        </article>
      </div>
    </section>
  );
}

export default About;
